import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class offlineService {
  baseUrl: string = environment.cloudUrl;
  notiCountUrl: string = this.baseUrl + 'password/request/notification';
  private socket: Socket;

  constructor(
    private messageService: MessageService,
    private http: HttpClient
  ) {}

  setupSocketConnection() {
    this.socket = io(environment.SOCKET_ENDPOINT, { autoConnect: true });
    console.log(this.socket);

    // this.offlineNotify.emit('planChange', this.socket.id);
    // this.socket.on('notification', (data) => {
    //   alert(data);
    // });
  }
  // {
  //   reconnection: true,
  //   reconnectionAttempts: 99999,
  //   reconnectionDelay: 1000,
  //   reconnectionDelayMax: 5000,
  // }

  listen(eventName: string) {
    return new Observable((subscribe) => {
      this.socket.on(eventName, (data) => {
        subscribe.next(data);
        return data;
      });
    });
  }

  emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
    return data;
  }

  count(id): Observable<any> {
    const url = `${this.notiCountUrl}/${id.userid}`;
    return this.http.get(url);
  }
}
